import { useDeployVersionCheck } from "../hooks/useDeployVersionCheck";

/** Verifica em background se há deploy novo e força reload quando necessário. */
export function DeployVersionGuard(): null {
  useDeployVersionCheck();
  return null;
}
